import React, { useState, useEffect } from 'react';
import useAxios from 'hooks/useAxios';
import ReactStrapTable from 'components/reactStrapTable';
//import {PharmacySummaryColumns} from 'utils/columns';
import Loader from 'components/Loader';
import { onExport } from 'utils/helper';
import { PharmacyVolumeSummaryColumns } from 'utils/columns';
import { cloneDeep } from 'lodash'; 
const PharmacyVolumeSummary = (props)=>{
    const API = useAxios();
    const {dateRange, planId, groupId, filter} = props;
    const [summaryData, setSummaryData] = useState([]);
    const [submitting, setSubmitting] = useState(false);
    const [totalSize, setTotalSize] = useState(0);
const [loading, setLoading] = useState(false);  
    const [state, updateState] = useState({
        filters: filter,
      });

      const setState = (state) => updateState((pre) => ({ ...pre, ...state }));

    useEffect(()=>{
        getPharmacyVolumeSummary(state.filters);
    },[]);

    const getPharmacyVolumeSummary = async(filters)=>{
        setSubmitting(true);
        setLoading(true);
        try{
            const {data}= await API.post(
                `/PBMTenant/${planId}/PBMClientDashboard/getTopPharmacyByVolumeSummary`, filters);
                if(data)
                {
                    setSummaryData(data.items);
                    setTotalSize(data.totalRecords);
                    setSubmitting(false);
                    setLoading(false);
                }
        }
        catch(ex)
        {
            setSubmitting(false);
        }
        
    };
    const { filters: colFilter } = state;

 const onPageChange = (filterr, hasColFilter, colChangedFilter) => {
                filter.pageSize = filterr.pageSize;
      filter.currentPage = filterr.currentPage;
                if (filterr.order != "" && filterr.orderBy != "") {
         const filterObj = cloneDeep(filter);
           filterObj.order=filterr.order;
            filterObj.orderBy=filterr.orderBy;
       filterObj.pageSize=filterr.pageSize;
       filterObj.currentPage=filterr.currentPage ;
           getPharmacyVolumeSummary(filterObj);
           }
          
               if (hasColFilter) {
                 setState({
                   filters: filterr,
                 });
                 let colFilterOn = { ...filterr, filters: colChangedFilter };
                 getPharmacyVolumeSummary();
                
               } else {
                var pageFilter = state.filters;
                pageFilter = {...state.filters, ...filterr};
                 setState({
                   filters: pageFilter,
                 });
                 getPharmacyVolumeSummary(pageFilter);
               }
             };
            const handleSort = (filter1, hasColFilter) => {
          
           if (hasColFilter) {
             filter1.pageSize=filter.pageSize
             filter1.currentPage=filter.currentPage
             onPageChange(filter1, true);
           } else {
               filter1.pageSize=filter.pageSize
             filter1.currentPage=filter.currentPage
             onPageChange(filter1, true);
           }
         };

             const handleSearchColumnFilters = async (colFilter) => {
                                                  
                                                     const filterObj = cloneDeep(filter);
                                                     if (colFilter && colFilter.length > 0) {
                                                       filterObj.filters=colFilter;
                                                     }
                                                     getPharmacyVolumeSummary(filterObj);
                                                   };
                                                  
                                                    const handleFilterCancel = () => {
                                                     var filterss = state.filters;
                                                    const filterObj = cloneDeep(filterss);
                                                 
                                                    filterObj.filters=[];
                                                 getPharmacyVolumeSummary(filterObj);
                                                   };  
      

      const handleExport = async () => {
        const { access_token } = JSON.parse(localStorage.getItem('pharmaforce')) || {};
        const action = `${process.env.REACT_APP_PBMCONFIG_ENDPOINT}/PBMTenant/${planId}/PBMClientDashboard/getTopPharmacyByVolumeSummaryExport?access_token=${access_token}`;
        onExport(action, state.filters);
      };
    

    return (
        <div
            className='table-card scroll-table position-relative border-0 rounded pt-0'
            fixed-height={summaryData?.length > 0 ? 'fixed-height' : 'default'}
        >
            {submitting && <Loader opacity={0.01} color='black' />}
            <ReactStrapTable
                id='invoicedetail-table'
                fixedColumn
                data={summaryData}
                filters={filter}
                columns={PharmacyVolumeSummaryColumns}
                onPageChange={onPageChange}
                onPageSizeChange={onPageChange}
                hasPagination
                pageSize={colFilter.pageSize}
                currentPage={colFilter.currentPage}
                totalRecords={totalSize}
                hasFilterColumn={false}
                onExport={handleExport}
                gridMsg="No Data"
                 handleSort={handleSort}
                 loading={loading}
                  onFilterCancel={handleFilterCancel}
               onSearchColumnFilters={handleSearchColumnFilters}
            />
        </div>
    );
}

export default PharmacyVolumeSummary;